import api from 'api'

const getAction = async (courseId: number) => {
  return api.get(`/courses/${courseId}/action_resolver`)
}

export const actionResolverService = {
  getAction,
}
